import apiService from './apiService';

/**
 * Service pour les échantillons de produits
 */
class SampleProductService {
  /**
   * Récupère la liste des échantillons avec filtres
   * @param {Object} params - Paramètres de recherche (search, paginate, orderby, order)
   */
  async getSampleProducts(params = {}) {
    const response = await apiService.get('/sample-product-variants', params);
    return response.data;
  }

  /**
   * Récupère un échantillon spécifique
   * @param {string} id - ID de l'échantillon
   */
  async getSampleProduct(id) {
    const response = await apiService.get(`/sample-product-variants/${id}`);
    return response.data;
  }

  /**
   * Crée un nouvel échantillon de produit
   * @param {Object} sampleData - Données de l'échantillon
   */
  async createSampleProduct(sampleData) {
    const response = await apiService.post('/sample-product-variants', sampleData);
    return response.data;
  }

  /**
   * Met à jour un échantillon de produit
   * @param {string} id - ID de l'échantillon
   * @param {Object} sampleData - Nouvelles données
   */
  async updateSampleProduct(id, sampleData) {
    const response = await apiService.put(`/sample-product-variants/${id}`, sampleData);
    return response.data;
  }

  /**
   * Supprime un échantillon de produit
   * @param {string} id - ID de l'échantillon
   */
  async deleteSampleProduct(id) {
    return apiService.delete(`/sample-product-variants/${id}`);
  }
}

const sampleProductServiceInstance = new SampleProductService();
export default sampleProductServiceInstance;
